import React from 'react';
import { renderDateTimePicker as RenderDateTimePicker } from 'components/form/datepicker/datetime-picker';

export default ({ label, input, meta, disabled, labelSize, qaId }) => (
  <RenderDateTimePicker
    label={label}
    input={input}
    meta={meta}
    disabled={disabled}
    labelSize={labelSize}
    qaId={qaId}
  />
);
